export enum IMAGE_FOLDER {
  ADMIN = "ADMIN_PROFILE",
}
export const IMAGE_EXT=["jpg", "jpeg", "png"]

